import { numberWithCommas } from 'app/libs/number';

const CATEGORY_TYPE = {
	BASIC: 'BASIC',
	INTERIOR: 'INTERIOR',
	STATE: 'STATE',
	EXTERIOR: 'EXTERIOR',
	ETC: 'ETC',
	DIAGNOSIS: 'DIAGNOSIS',
};

const CATEGORY_TYPE_NAME = {
	[CATEGORY_TYPE.BASIC]: '기본정보',
	[CATEGORY_TYPE.INTERIOR]: '실내',
	[CATEGORY_TYPE.STATE]: '휠타이어',
	[CATEGORY_TYPE.EXTERIOR]: '외관',
	[CATEGORY_TYPE.ETC]: '부가정보',
	[CATEGORY_TYPE.DIAGNOSIS]: '옵션',
};

const DIAGNOSIS_SUB_CATEGORY = {
	'01': '외관/내장',
	'02': '안전',
	'03': '편의/멀티미디어',
	'04': '시트',
};

const VALUE_TYPE = {
	SELECT: 'SELECT',
	MULTI_SELECT: 'MULTI_SELECT',
	NUMBER: 'NUMBER',
	TEXT: 'TEXT',
	TEXTAREA: 'TEXTAREA',
	PICTURE: 'PICTURE',
};

const COMMON_VALUE = {
	통과: 'PASS',
	알림: 'CHECK',
};

const COMMON_VALUE_NAME = {
	[COMMON_VALUE.통과]: '통과',
	[COMMON_VALUE.알림]: '알림',
};

const INCLUDE_VLAUE = {
	있음: 'INCLUDE',
	없음: 'NOT_INCLUDE',
};

const INCLUDE_VLAUE_NAME = {
	[INCLUDE_VLAUE.있음]: '있음',
	[INCLUDE_VLAUE.없음]: '없음',
};

const DIAGNOSIS_VALUE = {
	통과: 'PASS',
	알림: 'CHECK',
};

const DIAGNOSIS_VALUE_NAME = {
	[DIAGNOSIS_VALUE.통과]: '통과',
	[DIAGNOSIS_VALUE.알림]: '알림',
};

const KEY_QUANTITY = {
	'1개': '1',
	'2개': '2',
	'3개': '3',
};

const KEY_QUANTITY_NAME = {
	[KEY_QUANTITY['1개']]: '1개',
	[KEY_QUANTITY['2개']]: '2개',
	[KEY_QUANTITY['3개']]: '3개',
};

const SMELL = {
	양호: 'FINE',
	알림: 'SMOKE',
};

const SMELL_NAME = {
	[SMELL.양호]: '양호',
	[SMELL.알림]: '알림',
};

const OPTION_TYPE = {
	NEGATIVE: ['CHECK', 'NOT_INCLUDE', 'SMOKE', 'NEED_CHECK', 'NOT_EXISTS'],
};

const CHANGE_OPTION_VALUE = {
	'1열실내등': 38,
	'2열실내등': 56,
	운전석측면유리: 153,
	동승석측면유리: 216,
	운전석앞_휠: 80,
	운전석뒤_휠: 87,
	동승석뒤_휠: 94,
	동승석앞_휠: 101,
	전동시트_운전석: '021',
	전동시트_동승석: '035',
	전동시트_뒷좌석: '089',
	열선시트_앞좌석: '022',
	열선시트_뒷좌석: '063',
	통풍시트_운전석: '034',
	통풍시트_동승석: '077',
	통풍시트_뒷좌석: '090',
	정면유리_틴팅: 16,
	실내냄새: 17,
};
const CHANGE_OPTION_NAME = {
	[CHANGE_OPTION_VALUE['1열실내등']]: '1열 실내등',
	[CHANGE_OPTION_VALUE['2열실내등']]: '2열 실내등',
	[CHANGE_OPTION_VALUE['운전석측면유리']]: '운전석 측면 유리',
	[CHANGE_OPTION_VALUE['동승석측면유리']]: '동승석 측면 유리',
	[CHANGE_OPTION_VALUE['운전석앞_휠']]: '운전석(앞)_휠',
	[CHANGE_OPTION_VALUE['운전석뒤_휠']]: '운전석(뒤)_휠',
	[CHANGE_OPTION_VALUE['동승석뒤_휠']]: '동승석(뒤)_휠',
	[CHANGE_OPTION_VALUE['동승석앞_휠']]: '동승석(앞)_휠',
	[CHANGE_OPTION_VALUE['전동시트_운전석']]: '전동 시트(운전석)',
	[CHANGE_OPTION_VALUE['전동시트_동승석']]: '전동 시트(동승석)',
	[CHANGE_OPTION_VALUE['전동시트_뒷좌석']]: '전동 시트(뒷좌석)',
	[CHANGE_OPTION_VALUE['열선시트_앞좌석']]: '열선 시트(앞좌석)',
	[CHANGE_OPTION_VALUE['열선시트_뒷좌석']]: '열선 시트(뒷좌석)',
	[CHANGE_OPTION_VALUE['통풍시트_운전석']]: '통풍 시트(운전석)',
	[CHANGE_OPTION_VALUE['통풍시트_동승석']]: '통풍 시트(동승석)',
	[CHANGE_OPTION_VALUE['통풍시트_뒷좌석']]: '통풍 시트(뒷좌석)',
	[CHANGE_OPTION_VALUE['정면유리_틴팅']]: '틴팅(앞 유리)',
	[CHANGE_OPTION_VALUE['실내냄새']]: '실내냄새',
};

export const FAULT_OPTIONS = {
	DIRTY: '오염',
	USED: '사용감',
	RIPPED: '찢어짐',
	CRUSH: '깨짐',
	SCRATCH: '흠집',
	DENT: '찍힘',
	BRUSH_TOUCH: '붓터치',
	DEFECTIVE_PAINTING: '도장',
	DEFECTIVE: '작동',
	NO_SDCARD: 'SD카드 없음',
	DEFECTIVE_BUTTON: '버튼 불량',
	NO_PROBLEM: '문제 안됨',
	NEEDS_CHECK: '확인 필요',
	NEEDS_RESTORE: '복원 필요',
	MOISTURE: '습기',
	GAP: '단차',
	EFFLORESCENCE: '백화현상',
	SMOKE: '담배',
	ETC: '기타',
};

// 결함유형별 노출 문구 (위키 132187646 원문, 2025-12-03 갱신본 기준). $$는 buildCheckpointDesc에서 항목명으로 치환.
// 케이스가 갈리는 항목은 핵심 문장은 동일하고 CTA만 다름 — "엔카믿고 상담원을 통해"(엔카믿고 진입) vs "엔카믿고 신청시 상담을 통해"(그 외 진입).
export const REPORT_FAULT_DESC = {
	DIRTY: '점검 중 $$에 오염을 확인하였습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
	USED: {
		status: {
			NO_PROBLEM: '점검 중 $$에 약간의 사용감을 확인하였으나, 크게 눈에 띄지 않는 정도입니다.',
			NEEDS_CHECK:
				'점검 중 $$에 사용감을 확인하였으나, 연식/주행거리 대비 잘 관리되어 있습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
		},
	},
	RIPPED: '점검 중 $$에 일부 찢어짐을 확인하였습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
	CRUSH: '점검 중 $$에 일부 깨짐을 확인하였습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
	SCRATCH: {
		status: {
			NO_PROBLEM: '점검 중 $$에 미세한 스크래치를 확인하였으나, 눈에 거의 띄지 않는 정도입니다.',
			NEEDS_CHECK:
				'점검 중 $$에 스크래치를 확인하였으나, 중고차 특성상 흔히 보일 수 있는 정도입니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
			NEEDS_RESTORE:
				'점검 중 $$에 스크래치를 확인하였으며, 복원이 필요할 수 있습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
		},
	},
	DENT: {
		status: {
			NO_PROBLEM: '점검 중 $$에 미세한 찍힘을 확인하였으나, 눈에 거의 띄지 않는 정도입니다.',
			NEEDS_CHECK:
				'점검 중 $$에 찍힘을 확인하였으나, 중고차 특성상 흔히 보일 수 있는 정도입니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
			NEEDS_RESTORE: '점검 중 $$에 찍힘을 확인하였으며, 복원이 필요할 수 있습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
		},
	},
	BRUSH_TOUCH: '점검 중 $$에 일부 붓펜 터치업 작업(흠집 복원 작업)을 확인하였으나, 눈에 거의 띄지 않는 정도입니다.',
	DEFECTIVE_PAINTING: '점검 중 $$의 도장 상태에 이상을 확인하였습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
	DEFECTIVE: '점검 중 작동 이상을 확인하였습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
	NO_SDCARD: null, // 문구 삭제 — 노출하지 않음 (위키 확정)
	DEFECTIVE_BUTTON: '점검 중 버튼 작동 이상을 확인하였습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
	EMPTY: null, // 문구 삭제 — 노출하지 않음 (위키 확정)
	MOISTURE:
		'점검 중 램프 내 습기를 확인하였습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다. (*차량 확인 당시 일시적인 현상일 수 있습니다.)',
	GAP: '점검 중 해당 부위에 단차(차량 외관에서 이어지는 부분이 살짝 어긋나 있는 현상)를 확인하였습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
	EFFLORESCENCE: '점검 중 $$의 일부 부위에 백화 현상을 확인하였습니다. 자세한 내용은 엔카믿고 신청시 상담을 통해 확인 가능합니다.',
	SMOKE: '점검 중 차량 내부에서 특정 냄새를 확인하였습니다. 다만 냄새는 개인마다 느끼는 정도와 민감도가 다를 수 있어 구매 시 직접 확인해보시기를 권장합니다.',
	ETC: '점검 중 차량 내부에서 특정 냄새를 확인하였습니다. 다만 냄새는 개인마다 느끼는 정도와 민감도가 다를 수 있어 구매 시 직접 확인해보시기를 권장합니다.',
};

// 결함유형별 노출 문구 (엘란 관리자/믿고배송/믿고방문 진입) — 위와 shape 동일, CTA만 "엔카믿고 상담원을 통해"로 교체.
export const REPORT_FAULT_DESC_MEETGO = {
	DIRTY: '점검 중 $$에 오염을 확인하였습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
	USED: {
		status: {
			NO_PROBLEM: '점검 중 $$에 약간의 사용감을 확인하였으나, 크게 눈에 띄지 않는 정도입니다.',
			NEEDS_CHECK:
				'점검 중 $$에 사용감을 확인하였으나, 연식/주행거리 대비 잘 관리되어 있습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
		},
	},
	RIPPED: '점검 중 $$에 일부 찢어짐을 확인하였습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
	CRUSH: '점검 중 $$에 일부 깨짐을 확인하였습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
	SCRATCH: {
		status: {
			NO_PROBLEM: '점검 중 $$에 미세한 스크래치를 확인하였으나, 눈에 거의 띄지 않는 정도입니다.',
			NEEDS_CHECK:
				'점검 중 $$에 스크래치를 확인하였으나, 중고차 특성상 흔히 보일 수 있는 정도입니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
			NEEDS_RESTORE: '점검 중 $$에 스크래치를 확인하였으며, 복원이 필요할 수 있습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
		},
	},
	DENT: {
		status: {
			NO_PROBLEM: '점검 중 $$에 미세한 찍힘을 확인하였으나, 눈에 거의 띄지 않는 정도입니다.',
			NEEDS_CHECK:
				'점검 중 $$에 찍힘을 확인하였으나, 중고차 특성상 흔히 보일 수 있는 정도입니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
			NEEDS_RESTORE: '점검 중 $$에 찍힘을 확인하였으며, 복원이 필요할 수 있습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
		},
	},
	BRUSH_TOUCH: '점검 중 $$에 일부 붓펜 터치업 작업(흠집 복원 작업)을 확인하였으나, 눈에 거의 띄지 않는 정도입니다.',
	DEFECTIVE_PAINTING: '점검 중 $$의 도장 상태에 이상을 확인하였습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
	DEFECTIVE: '점검 중 작동 이상을 확인하였습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
	NO_SDCARD: null,
	DEFECTIVE_BUTTON: '점검 중 버튼 작동 이상을 확인하였습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
	EMPTY: null,
	MOISTURE:
		'점검 중 램프 내 습기를 확인하였습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다. (*차량 확인 당시 일시적인 현상일 수 있습니다.)',
	GAP: '점검 중 해당 부위에 단차(차량 외관에서 이어지는 부분이 살짝 어긋나 있는 현상)를 확인하였습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
	EFFLORESCENCE: '점검 중 $$의 일부 부위에 백화 현상을 확인하였습니다. 자세한 내용은 엔카믿고 상담원을 통해 확인 가능합니다.',
	SMOKE: '점검 중 차량 내부에서 특정 냄새를 확인하였습니다. 다만 냄새는 개인마다 느끼는 정도와 민감도가 다를 수 있어 구매 시 직접 확인해보시기를 권장합니다.',
	ETC: '점검 중 차량 내부에서 특정 냄새를 확인하였습니다. 다만 냄새는 개인마다 느끼는 정도와 민감도가 다를 수 있어 구매 시 직접 확인해보시기를 권장합니다.',
};

// 차량리포트 가격(원) — 표기·지표가 공유하는 단일 소스
export const REPORT_PRICE = 2000;

// 차량리포트 가격 표기 문자열 — 리포트 전 영역 공통
export const REPORT_ORIGIN_PRICE = `${numberWithCommas(REPORT_PRICE)}원`;

export const REPORT_TAB_CONTENTS = {
	기본정보: {
		desc: '차량 키, 매뉴얼, 주요 소모품\n장착 여부 등을 확인했어요',
		title: '기본정보',
		category: 'BASIC',
		data: 'basicData',
	},
	등화장치: {
		desc: '내&외부 등화장치의 상태와\n작동 유무를 확인했어요',
		title: '등화장치',
		category: 'LIGHT',
		data: 'lightData',
	},
	실내: {
		desc: '실내 내장 상태와\n차량 시트를 확인했어요',
		title: '실내',
		category: 'INTERIOR',
		data: 'interiorData',
	},
	외관: {
		desc: '주요 외관의 상태와\n차량 유리를 확인했어요',
		title: '외관',
		category: 'EXTERIOR',
		data: 'exteriorData',
	},
	휠타이어: {
		desc: '휠 상태와 트레드 잔량 등을\n꼼꼼하게 확인했어요',
		title: '휠타이어',
		category: 'STATE',
		data: 'stateData',
	},
	옵션: {
		desc: '옵션의 장착여부를\n확인했어요',
		title: '옵션',
		category: 'DIAGNOSIS',
		data: 'diagnosisData',
	},
};

const BASIC = {
	전면사진: 1,
	사이드_리피터_운전석: 2,
	사이드_리피터_동승석: 3,
	전면램프_운전석: 4,
	전면램프_동승석: 5,
	후면사진: 6,
	후면램프_운전석: 7,
	후면램프_동승석: 8,
	번호판_램프: 9,
	차량키: 331,
	차량키_사진: 332,
	차량키_내용: 338,
	차량키수량: 10,
	제조사매뉴얼: 11,
	제조사매뉴얼_사진: 337,
	제조사매뉴얼_내용: 324,
	블랙박스: 13,
	블랙박스_사진: 14,
	블랙박스_내용: 15,
	정면유리_틴팅: 16,
	정면유리_틴팅_사진: 18,
	정면유리_틴팅_내용: 19,
	실내냄새: 17,
	실내냄새_내용: 343,
};

const INTERIOR = {
	실내1열: {
		title: '실내 1열',
		isRequired: false,
		항목: [
			{
				계기판: 20,
				계기판_사진: 21,
				계기판_내용: 22,
			},
			{
				핸들: 23,
				핸들_사진: 24,
				핸들_내용: 25,
			},
			{
				대시보드: 26,
				대시보드_사진: 27,
				대시보드_내용: 28,
			},
			{
				센터페시아: 29,
				센터페시아_사진: 30,
				센터페시아_내용: 31,
			},
			{
				앞좌석송풍구: 32,
				앞좌석송풍구_사진: 33,
				앞좌석송풍구_내용: 34,
			},
			{
				콘솔글로브박스: 35,
				콘솔글로브박스_사진: 36,
				콘솔글로브박스_내용: 37,
			},
			{
				실내등_파손포함: 38,
				실내등_파손포함_사진: 39,
				실내등_파손포함_내용: 40,
			},
			{
				화장등_파손포함: 41,
				화장등_파손포함_사진: 42,
				화장등_파손포함_내용: 43,
			},
			{
				필러: 44,
				필러_사진: 45,
				필러_내용: 46,
			},
			{
				천장: 47,
				천장_사진: 48,
				천장_내용: 49,
			},
		],
	},
	실내2열: {
		title: '실내 2열',
		isRequired: false,
		항목: [
			{
				에어밴드_뒷좌석송풍구: 50,
				에어밴드_뒷좌석송풍구_사진: 51,
				에어밴드_뒷좌석송풍구_내용: 52,
			},
			{
				암레스트: 53,
				암레스트_사진: 54,
				암레스트_내용: 55,
			},
			{
				실내등_파손포함: 56,
				실내등_파손포함_사진: 57,
				실내등_파손포함_내용: 58,
			},
			{
				필러: 59,
				필러_사진: 60,
				필러_내용: 61,
			},
			{
				천장: 62,
				천장_사진: 63,
				천장_내용: 64,
			},
		],
	},
	실내3열: {
		title: '실내 3열',
		isRequired: false,
		항목: [
			{
				에어밴드_송풍구: 65,
				에어밴드_송풍구_사진: 66,
				에어밴드_송풍구_내용: 67,
			},
			{
				암레스트: 68,
				암레스트_사진: 69,
				암레스트_내용: 70,
			},
			{
				실내등_파손포함: 71,
				실내등_파손포함_사진: 72,
				실내등_파손포함_내용: 73,
			},
			{
				필러: 74,
				필러_사진: 75,
				필러_내용: 76,
			},
			{
				천장: 77,
				천장_사진: 78,
				천장_내용: 79,
			},
		],
	},
};

const STATE = {
	운전석_전: {
		title: '운전석 (앞)',
		isRequired: true,
		항목: {
			휠: 80,
			휠_사진: 85,
			휠_내용: 86,
			제조사: 81,
			생산일: 82,
			트레드_잔량: [83, 327],
			휠하우스_커버: 84,
			휠하우스_커버_사진: 333,
			휠하우스_커버_내용: 339,
		},
	},
	운전석_후: {
		title: '운전석 (뒤)',
		isRequired: true,
		항목: {
			휠: 87,
			휠_사진: 92,
			휠_내용: 93,
			제조사: 88,
			생산일: 89,
			트레드_잔량: [90, 328],
			휠하우스_커버: 91,
			휠하우스_커버_사진: 334,
			휠하우스_커버_내용: 340,
		},
	},
	동승석_후: {
		title: '동승석 (뒤)',
		isRequired: true,
		항목: {
			휠: 94,
			휠_사진: 99,
			휠_내용: 100,
			제조사: 95,
			생산일: 96,
			트레드_잔량: [97, 329],
			휠하우스_커버: 98,
			휠하우스_커버_사진: 336,
			휠하우스_커버_내용: 342,
		},
	},
	동승석_전: {
		title: '동승석 (앞)',
		isRequired: true,
		항목: {
			휠: 101,
			휠_사진: 106,
			휠_내용: 107,
			제조사: 102,
			생산일: 103,
			트레드_잔량: [104, 330],
			휠하우스_커버: 105,
			휠하우스_커버_사진: 335,
			휠하우스_커버_내용: 341,
		},
	},
};

const EXTERIOR = {
	전면부: {
		title: '전면부',
		isRequired: false,
		항목: [
			{
				전면유리: 129,
				전면유리_사진: 130,
				전면유리_내용: 131,
			},
			{
				헤드램프_운전석: 108,
				헤드램프_운전석_사진: 109,
				헤드램프_운전석_내용: 110,
			},
			{
				헤드램프_동승석: 111,
				헤드램프_동승석_사진: 112,
				헤드램프_동승석_내용: 113,
			},
			{
				안개등_운전석: 114,
				안개등_운전석_사진: 115,
				안개등_운전석_내용: 116,
			},
			{
				안개등_동승석: 117,
				안개등_동승석_사진: 118,
				안개등_동승석_내용: 119,
			},
			{
				본네트: 120,
				본네트_사진: 121,
				본네트_내용: 122,
			},
			{
				라지에이터그릴: 123,
				라지에이터그릴_사진: 124,
				라지에이터그릴_내용: 125,
			},
			{
				앞범퍼: 126,
				앞범퍼_사진: 127,
				앞범퍼_내용: 128,
			},
		],
	},
	운전석: {
		title: '운전석 (도어트림, 시트 포함)',
		isRequired: false,
		항목: [
			{
				프론트휀더: 132,
				프론트휀더_사진: 133,
				프론트휀더_내용: 134,
			},
			{
				사이드미러: 135,
				사이드미러_사진: 136,
				사이드미러_내용: 137,
			},
			{
				측면유리: 153,
				측면유리_사진: 154,
				측면유리_내용: 155,
			},
			{
				필러: 147,
				필러_사진: 148,
				필러_내용: 149,
			},
			{
				앞문: 138,
				앞문_사진: 139,
				앞문_내용: 140,
			},
			{
				운전석_시트: 159,
				운전석_시트_사진: 160,
				운전석_시트_내용: 161,
			},
			{
				운전석_도어트림: 156,
				운전석_도어트림_사진: 157,
				운전석_도어트림_내용: 158,
			},
			{
				뒷문: 141,
				뒷문_사진: 142,
				뒷문_내용: 143,
			},
			{
				운전석_2열시트: 165,
				운전석_2열시트_사진: 166,
				운전석_2열시트_내용: 167,
			},
			{
				운전석_2열도어시트: 162,
				운전석_2열도어시트_사진: 163,
				운전석_2열도어시트_내용: 164,
			},
			{
				사이드스텝: 144,
				사이드스텝_사진: 145,
				사이드스텝_내용: 146,
			},
			{
				쿼터패널: 150,
				쿼터패널_사진: 151,
				쿼터패널_내용: 152,
			},
		],
	},
	후면부: {
		title: '후면부',
		isRequired: false,
		항목: [
			{
				테일램프_운전석: 168,
				테일램프_운전석_사진: 169,
				테일램프_운전석_내용: 170,
			},
			{
				테일램프_동승석: 171,
				테일램프_동승석_사진: 172,
				테일램프_동승석_내용: 173,
			},
			{
				번호판등: 174,
				번호판등_사진: 175,
				번호판등_내용: 176,
			},
			{
				유리: 177,
				유리_사진: 178,
				유리_내용: 179,
			},
			{
				트렁크외부: 180,
				트렁크외부_사진: 181,
				트렁크외부_내용: 182,
			},
			{
				트렁크내부: 183,
				트렁크내부_사진: 184,
				트렁크내부_내용: 185,
			},
			{
				리페어장비: 186,
				리페어장비_사진: 187,
				리페어장비_내용: 188,
			},
			{
				소화기: 189,
				소화기_사진: 190,
				소화기_내용: 191,
			},
			{
				범퍼: 192,
				범퍼_사진: 193,
				범퍼_내용: 194,
			},
		],
	},
	동승석: {
		title: '동승석 (도어트림, 시트 포함)',
		isRequired: false,
		항목: [
			{
				쿼터패널: 213,
				쿼터패널_사진: 214,
				쿼터패널_내용: 215,
			},
			{
				뒷문_도어캐치: 204,
				뒷문_도어캐치_사진: 205,
				뒷문_도어캐치_내용: 206,
			},
			{
				동승석_2열_시트: 228,
				동승석_2열_시트_사진: 229,
				동승석_2열_시트_내용: 230,
			},
			{
				동승석_2열도어트림: 225,
				동승석_2열도어트림_사진: 226,
				동승석_2열도어트림_내용: 227,
			},
			{
				앞문_도어캐치: 201,
				앞문_도어캐치_사진: 202,
				앞문_도어캐치_내용: 203,
			},
			{
				동승석_1열시트: 222,
				동승석_1열시트_사진: 223,
				동승석_1열시트_내용: 224,
			},
			{
				동승석_1열도어트림: 219,
				동승석_1열도어트림_사진: 220,
				동승석_1열도어트림_내용: 221,
			},
			{
				사이드스탭: 207,
				사이드스탭_사진: 208,
				사이드스탭_내용: 209,
			},
			{
				필러: 210,
				필러_사진: 211,
				필러_내용: 212,
			},
			{
				측면유리: 216,
				측면유리_사진: 217,
				측면유리_내용: 218,
			},
			{
				사이드미러: 198,
				사이드미러_사진: 199,
				사이드미러_내용: 200,
			},
			{
				프론트휀더: 195,
				프론트휀더_사진: 196,
				프론트휀더_내용: 197,
			},
		],
	},
	천장: {
		title: '천장 (루프)',
		isRequired: false,
		항목: [
			{
				루프: 231,
				루프_사진: 232,
				루프_내용: 233,
			},
		],
	},
};

const ETC = {
	차량등록증_사진: 234,
	성능기록부_사진: 235,
	의무성능보험료: 236,
	기타상세_내용: 238,
	정비내역서_사진: 239,
	보증서_사진: 240,
	기타_사진: 241,
	기타_내용: 242,
	외부외관상태_내용: 243,
	실내상태_내용: 244,
	휠타이어상태_내용: 246,
	총평_내용: 247,
};

const DIAGNOSIS = {
	외관_내관: {
		title: '외관/내장',
		isRequired: false,
		항목: [
			{
				선루프: '010',
				선루프_사진: 248,
				선루프_내용: 249,
			},
			{
				파워전동트렁크: '059',
				파워전동트렁크_사진: 250,
				파워전동트렁크_내용: 251,
			},
			{
				고스트도어클로징: '080',
				고스트도어클로징_사진: 252,
				고스트도어클로징_내용: 253,
			},
			{
				전동접이사이드미러: '024',
				전동접이사이드미러_사진: 254,
				전동접이사이드미러_내용: 255,
			},
			{
				열선스티어링휠: '082',
				열선스티어링휠_사진: 256,
				열선스티어링휠_내용: 257,
			},
			{
				전동조절스티어링휠: '083',
				전동조절스티어링휠_사진: 258,
				전동조절스티어링휠_내용: 259,
			},
			{
				스티어링휠리모컨: '031',
				스티어링휠리모컨_사진: 260,
				스티어링휠리모컨_내용: 261,
			},
			{
				ECM룸미러: '030',
				ECM룸미러_사진: 262,
				ECM룸미러_내용: 263,
			},
			{
				하이패스: '074',
				하이패스_사진: 264,
				하이패스_내용: 265,
			},
			{
				파워도어록: '006',
				파워도어록_사진: 266,
				파워도어록_내용: 267,
			},
			{
				파워윈도우: '007',
				파워윈도우_사진: 268,
				파워윈도우_내용: 269,
			},
		],
	},
	안전: {
		title: '안전',
		isRequired: false,
		항목: [
			{
				브레이크잠김방지: '001',
				브레이크잠금방지_사진: 270,
				브레이크잠금방지_내용: 271,
			},
			{
				미끄럼방지: '019',
				미끄럼방지_사진: 272,
				미끄럼방지_내용: 273,
			},
			{
				차체자세제어장치: '055',
				차체자세제어장치_사진: 274,
				차체자세제어장치_내용: 275,
			},
			{
				타이어공기압센서: '033',
				타이어공기압센서_사진: 276,
				타이어공기압센서_내용: 277,
			},
			{
				주차감지센서_전방: '085',
				주차감지센서_전방_사진: 278,
				주차감지센서_전방_내용: 279,
			},
			{
				주차감지센서_후방: '032',
				주차감지센서_후방_사진: 280,
				주차감지센서_후방_내용: 281,
			},
			{
				후방카메라: '058',
				후방카메라_사진: 282,
				후방카메라_내용: 283,
			},
			{
				'360어라운드뷰': '087',
				'360어라운드뷰_사진': 284,
				'360어라운드뷰_내용': 285,
			},
		],
	},
	편의_멀티미디어: {
		title: '편의/멀티미디어',
		isRequired: false,
		항목: [
			{
				HUD: '095',
				HUD_사진: 286,
				HUD_내용: 287,
			},
			{
				전자식주차브레이크: '094',
				전자식주차브레이크_사진: 288,
				전자식주차브레이크_내용: 289,
			},
			{
				자동에어컨: '023',
				자동에어컨_사진: 290,
				자동에어컨_내용: 291,
			},
			{
				스마트키: '057',
				스마트키_사진: 292,
				스마트키_내용: 293,
			},
			{
				무선도어잠금장치: '015',
				무선도어잠금장치_사진: 294,
				무선도어잠금장치_내용: 295,
			},
			{
				커튼블라인드_뒷좌석: '092',
				커튼블라인드_뒷자석_사진: 296,
				커튼블라인드_뒷좌석_내용: 297,
			},
			{
				커튼블라인드_후방: '093',
				커튼블라인드_후방_사진: 298,
				커튼블라인드_후방_내용: 299,
			},
			{
				내비게이션: '005',
				내비게이션_사진: 300,
				내비게이션_내용: 301,
			},
			{
				블루투스: '096',
				블루투스_사진: 302,
				블루투스_내용: 303,
			},
		],
	},
	시트: {
		title: '시트',
		isRequired: false,
		항목: [
			{
				전동시트_운전석: '021',
				전동시트_운전석_사진: 304,
				전동시트_운전석_내용: 305,
			},
			{
				전동시트_동승석: '035',
				전동시트_동승석_사진: 306,
				전동시트_동승석_내용: 307,
			},
			{
				전동시트_뒷좌석: '089',
				전동시트_뒷좌석_사진: 308,
				전동시트_뒷좌석_내용: 309,
			},
			{
				열선시트_앞좌석: '022',
				열선시트_앞좌석_사진: 310,
				열선시트_앞좌석_내용: 311,
			},
			{
				열선시트_뒷좌석: '063',
				열선시트_뒷좌석_사진: 312,
				열선시트_뒷좌석_내용: 313,
			},
			{
				메모리시트_운전석: '051',
				메모리시트_운전석_사진: 314,
				메모리시트_운전석_내용: 315,
			},
			{
				메모리시트_동승석: '078',
				메모리시트_동승석_사진: 316,
				메모리시트_동승석_내용: 317,
			},
			{
				통풍시트_운전석: '034',
				통풍시트_운전석_사진: 318,
				통풍시트_운전석_내용: 319,
			},
			{
				통풍시트_동승석: '077',
				통풍시트_동승석_사진: 326,
				통풍시트_동승석_내용: 325,
			},
			{
				통풍시트_뒷좌석: '090',
				통풍시트_뒷좌석_사진: 320,
				통풍시트_뒷좌석_내용: 321,
			},
			{
				마사지시트: '091',
				마사지시트_사진: 322,
				마사지시트_내용: 323,
			},
		],
	},
};

const PHOTO_GROUP = {
	basic: [1, 6, 332, 337, 14, 18],
	interior: [21, 24, 27, 30, 33, 36, 39, 42, 45, 48, 51, 54, 57, 60, 63, 66, 69, 72, 75, 78],
	state: [85, 333, 92, 334, 99, 336, 106, 335],
	exterior: [
		130, 109, 112, 115, 118, 121, 124, 127, 133, 136, 139, 142, 145, 148, 151, 154, 157, 160, 163, 166, 169, 172, 175, 178, 181, 184, 187, 190,
		193, 214, 205, 229, 226, 202, 223, 220, 208, 211, 217, 199, 196, 232,
	],
};

const REPORT_EXTERIOR_IMAGE_IDS = [1, 6, 18]; // 전면사진, 후면사진, 전면유리
const REPORT_INTERIOR_IMAGE_IDS = [160, 223, 166, 229, 184]; // 운전석 1열시트, 동승석 1열시트, 운전석 2열시트, 동승석 2열시트, 트렁크내부
const REPORT_STATE_IMAGE_IDS = [85, 92, 106, 99]; // 운전석앞 타이어,운전석뒤 타이어, 동승석앞 타이어, 동승석뒤타이어
const REPORT_ETC_IMAGE_IDS = [235, 239]; // 성능기록부, 정비내역서, 기타
const REPORT_DISABLE_IMAGE_IDS = [1, 6, 160]; // 전면사진, 후면사진, 운전석 시트 사진 (쿠션 현장촬영 섹션용)
const REPORT_CAR_DETAIL_IDS = [10, 16, 327, 328, 329, 330];
const REPORT_CAR_DETAIL_IMAGE_IDS = [1, 332, 85];

const REPORT_V2_CAR_DETAIL = {
	차량키_수량: 345,
	// 사진 세 장 (정책서 3-5·3-6·3-7) — 상세사진 전면 · 기본정보 차량키 · 상세사진 좌측면(타이어)
	전면_사진: 360,
	차량키_사진: 346,
	좌측면_사진: 368,
	타이어: {
		left: [
			{ position: 370, tread: 373 },
			{ position: 374, tread: 377 },
		],
		right: [
			{ position: 378, tread: 381 },
			{ position: 382, tread: 385 },
		],
	},
};

/** 위 카탈로그에서 조회에 실을 optionId 를 모은 것 */
const REPORT_V2_CAR_DETAIL_IDS = [
	REPORT_V2_CAR_DETAIL.차량키_수량,
	REPORT_V2_CAR_DETAIL.전면_사진,
	REPORT_V2_CAR_DETAIL.차량키_사진,
	REPORT_V2_CAR_DETAIL.좌측면_사진,
	...[...REPORT_V2_CAR_DETAIL.타이어.left, ...REPORT_V2_CAR_DETAIL.타이어.right].flatMap((slot) => [slot.position, slot.tread]),
];
const REPORT_BASIC = {
	성능점검기록부: { category: 'etc', id: 235 },
	기타정비내역: { category: 'etc', id: 239 },
	'차량 키 수량': { category: 'basic', id: 10 },
	'제조사 매뉴얼': { category: 'basic', id: 11 },
	// 블랙박스: { category: 'basic', id: 13 },
	'틴팅 (정면 유리)': { category: 'basic', id: 16 },
	// '실내 냄새': { category: 'basic', id: 17 },
	'리페어 장비': { category: 'exterior', id: 186 },
	소화기: { category: 'exterior', id: 189 },
};
const REPORT_BASIC_TOTAL = {
	// '외부 & 외관 상태': { category: 'etc', id: 243 },
	// '실내 상태': { category: 'etc', id: 244 },
	// '시트 상태': { category: 'etc', id: 245 },
	// '휠 & 타이어 상태': { category: 'etc', id: 246 },
	총평: { category: 'etc', id: 247 },
};
const REPORT_BASIC_PHOTO = {
	성능기록부: { category: 'etc', id: 235 },
	정비내역서: { category: 'etc', id: 239 },
	차량키_사진: { category: 'basic', id: 332 },
	제조사매뉴얼_사진: { category: 'basic', id: 337 },
	// 블랙박스: { category: 'basic', id: 14 },
	'틴팅(앞 유리)': { category: 'basic', id: 18 },
	리페어장비: { category: 'exterior', id: 187 },
	소화기: { category: 'exterior', id: 190 },
};
const REPORT_BASIC_NEGATIVE = {
	성능점검기록부: { category: 'etc', id: 235, text: '성능점검기록부가 없습니다' },
	기타정비내역: { category: 'etc', id: 239, text: '기타 정비 내역서가 없습니다' },
	'제조사 매뉴얼': { category: 'basic', id: 11, text: '제조사 메뉴얼이 없습니다.' },
	// 블랙박스: { category: 'basic', id: 13, text: '블랙박스가 없습니다.' },
	'틴팅 (정면 유리)': { category: 'basic', id: 16, text: '정면유리의 틴팅이 없습니다.' },
	// '실내 냄새': { category: 'basic', id: 17, text: '실내에서 담배냄새가 확인되었습니다.' },
	'리페어 장비': { category: 'exterior', id: 186, text: '리페어 장비가 없습니다.' },
	소화기: { category: 'exterior', id: 189, text: '소화기가 없습니다.' },
};
const REPORT_LIGHT_PHOTO = {
	전면사진: { category: 'basic', id: 1 },
	후면사진: { category: 'basic', id: 6 },
};
const REPORT_PHOTO_GROUP = {
	major: [
		{ name: '전면 사진', value: 1 },
		{ name: '후면 사진', value: 6 },
		{ name: '전면 유리', value: 18 },
		{ name: '운전석 1열시트', value: 160 },
		{ name: '동승석 1열시트', value: 223 },
		{ name: '운전석 2열시트', value: 166 },
		{ name: '동승석 2열시트', value: 229 },
		{ name: '트렁크내부', value: 184 },
		{ name: '운전석앞 타이어', value: 85 },
		{ name: '운전석뒤 타이어', value: 92 },
		{ name: '동승석앞 타이어', value: 106 },
		{ name: '동승석뒤 타이어', value: 99 },
	],
	etc: [
		{ name: '성능기록부', value: 235 },
		{ name: '정비내역서', value: 239 },
	],
	check: [
		{ name: '성능기록부', value: 235 },
		{ name: '정비내역서', value: 239 },
		{ name: '차량키', value: 332 },
		{ name: '제조사매뉴얼', value: 337 },
		// { name: '블랙박스', value: 14 },
		{ name: '정면유리_틴팅', value: 18 },
		{ name: '리페어장비', value: 187 },
		{ name: '소화기', value: 190 },
	],
};
const REPORT_LIGHT = {
	exterior: {
		항목: [
			{
				헤드램프_운전석: 108,
				헤드램프_운전석_사진: 109,
				헤드램프_운전석_내용: 110,
			},
			{
				헤드램프_동승석: 111,
				헤드램프_동승석_사진: 112,
				헤드램프_동승석_내용: 113,
			},
			{
				안개등_운전석: 114,
				안개등_운전석_사진: 115,
				안개등_운전석_내용: 116,
			},
			{
				안개등_동승석: 117,
				안개등_동승석_사진: 118,
				안개등_동승석_내용: 119,
			},
			{
				테일램프_운전석: 168,
				테일램프_운전석_사진: 169,
				테일램프_운전석_내용: 170,
			},
			{
				테일램프_동승석: 171,
				테일램프_동승석_사진: 172,
				테일램프_동승석_내용: 173,
			},
			{
				번호판등: 174,
				번호판등_사진: 175,
				번호판등_내용: 176,
			},
		],
	},
	interior: {
		항목: [
			{
				'1열실내등_파손포함': 38,
				'1열실내등_파손포함_사진': 39,
				'1열실내등_파손포함_내용': 40,
			},
			{
				'2열실내등_파손포함': 56,
				'2열실내등_파손포함_사진': 57,
				'2열실내등_파손포함_내용': 58,
			},
			{
				화장등_파손포함: 41,
				화장등_파손포함_사진: 42,
				화장등_파손포함_내용: 43,
			},
		],
	},
};
const REPORT_INTERIOR_MATERIAL = {
	interior: {
		항목: [
			{
				계기판: 20,
				계기판_사진: 21,
				계기판_내용: 22,
			},
			{
				핸들: 23,
				핸들_사진: 24,
				핸들_내용: 25,
			},
			// {
			// 	대시보드: 26,
			// 	대시보드_사진: 27,
			// 	대시보드_내용: 28,
			// },
			{
				센터페시아: 29,
				센터페시아_사진: 30,
				센터페시아_내용: 31,
			},
			{
				앞좌석송풍구: 32,
				앞좌석송풍구_사진: 33,
				앞좌석송풍구_내용: 34,
			},
			{
				콘솔글로브박스: 35,
				콘솔글로브박스_사진: 36,
				콘솔글로브박스_내용: 37,
			},
			{
				에어밴드_뒷좌석송풍구: 50,
				에어밴드_뒷좌석송풍구_사진: 51,
				에어밴드_뒷좌석송풍구_내용: 52,
			},
			{
				암레스트: 53,
				암레스트_사진: 54,
				암레스트_내용: 55,
			},
		],
	},
	exterior: {
		항목: [
			{
				트렁크내부: 183,
				트렁크내부_사진: 184,
				트렁크내부_내용: 185,
			},
			{
				필러: 210,
				필러_사진: 211,
				필러_내용: 212,
			},
		],
	},
};
const REPORT_INTERIOR_MATERIAL2 = {
	interior: {
		항목: [
			{
				천장: 47,
				천장_사진: 48,
				천장_내용: 49,
			},
			{
				천장: 62,
				천장_사진: 63,
				천장_내용: 64,
			},
			{
				천장: 77,
				천장_사진: 78,
				천장_내용: 79,
			},
		],
	},
};
const REPORT_INTERIOR_SHEET = {
	exterior: {
		항목: [
			{
				운전석_도어트림: 156,
				운전석_도어트림_사진: 157,
				운전석_도어트림_내용: 158,
			},
			{
				운전석_2열도어트림: 162,
				운전석_2열도어트림_사진: 163,
				운전석_2열도어트림_내용: 164,
			},
			{
				동승석_도어트림: 219,
				동승석_도어트림_사진: 220,
				동승석_도어트림_내용: 221,
			},
			{
				동승석_2열도어트림: 225,
				동승석_2열도어트림_사진: 226,
				동승석_2열도어트림_내용: 227,
			},
			{
				운전석_시트: 159,
				운전석_시트_사진: 160,
				운전석_시트_내용: 161,
			},
			{
				동승석_시트: 222,
				동승석_시트_사진: 223,
				동승석_시트_내용: 224,
			},
			{
				운전석_2열시트: 165,
				운전석_2열시트_사진: 166,
				운전석_2열시트_내용: 167,
			},
		],
	},
};

const REPORT_EXTERIOR_FRONT = {
	exterior: {
		항목: [
			{
				본네트: 120,
				본네트_사진: 121,
				본네트_내용: 122,
			},
			{
				라지에이터그릴: 123,
				라지에이터그릴_사진: 124,
				라지에이터그릴_내용: 125,
			},
			{
				앞범퍼: 126,
				앞범퍼_사진: 127,
				앞범퍼_내용: 128,
			},
		],
	},
};

const REPORT_EXTERIOR_DRIVER = {
	exterior: {
		항목: [
			{
				프론트휀더: 132,
				프론트휀더_사진: 133,
				프론트휀더_내용: 134,
			},
			{
				사이드미러: 135,
				사이드미러_사진: 136,
				사이드미러_내용: 137,
			},
			{
				앞문: 138,
				앞문_사진: 139,
				앞문_내용: 140,
			},
			{
				뒷문: 141,
				뒷문_사진: 142,
				뒷문_내용: 143,
			},
			{
				필러: 147,
				필러_사진: 148,
				필러_내용: 149,
			},
			{
				쿼터패널: 150,
				쿼터패널_사진: 151,
				쿼터패널_내용: 152,
			},
			{
				사이드스텝: 144,
				사이드스텝_사진: 145,
				사이드스텝_내용: 146,
			},
		],
	},
};

const REPORT_EXTERIOR_PASSENGER = {
	exterior: {
		항목: [
			{
				프론트휀더: 195,
				프론트휀더_사진: 196,
				프론트휀더_내용: 197,
			},
			{
				사이드미러: 198,
				사이드미러_사진: 199,
				사이드미러_내용: 200,
			},
			{
				앞문: 201,
				앞문_사진: 202,
				앞문_내용: 203,
			},
			{
				뒷문: 204,
				뒷문_사진: 205,
				뒷문_내용: 206,
			},
			{
				필러: 210,
				필러_사진: 211,
				필러_내용: 212,
			},
			{
				쿼터패널: 213,
				쿼터패널_사진: 214,
				쿼터패널_내용: 215,
			},
			{
				사이드스탭: 207,
				사이드스탭_사진: 208,
				사이드스탭_내용: 209,
			},
		],
	},
};
const REPORT_EXTERIOR_REAR = {
	exterior: {
		항목: [
			{
				트렁크외부: 180,
				트렁크외부_사진: 181,
				트렁크외부_내용: 182,
			},
			{
				범퍼: 192,
				범퍼_사진: 193,
				범퍼_내용: 194,
			},
		],
	},
};
const REPORT_EXTERIOR_ROOF = {
	exterior: {
		항목: [
			{
				루프: 231,
				루프_사진: 232,
				루프_내용: 233,
			},
		],
	},
};
const REPORT_EXTERIOR_GLASS = {
	exterior: {
		항목: [
			{
				전면유리: 129,
				전면유리_사진: 130,
				전면유리_내용: 131,
			},
			{
				운전석측면유리: 153,
				운전석측면유리_사진: 154,
				운전석측면유리_내용: 155,
			},
			{
				동승석측면유리: 216,
				동승석측면유리_사진: 217,
				동승석측면유리_내용: 218,
			},
			{
				후면유리: 177,
				후면유리_사진: 178,
				후면유리_내용: 179,
			},
		],
	},
};

const REPORT_STATE_FRONT = {
	state: {
		항목: [
			{ 휠: 80, 휠_사진: 85, 휠_내용: 86 },
			{ 제조사: 81 },
			{ 생산일: 82 },
			{ 트레드_잔량: 83 },
			{ 트레드_잔량_mm: 327, 휠_사진: 85 },
			{ 휠하우스_커버: 84, 휠하우스_커버_사진: 333 },
		],
	},
};
const REPORT_STATE_BACK = {
	state: {
		항목: [
			{ 휠: 87, 휠_사진: 92, 휠_내용: 93 },
			{ 제조사: 88 },
			{ 생산일: 89 },
			{ 트레드_잔량: 90 },
			{ 트레드_잔량_mm: 328, 휠_사진: 92 },
			{ 휠하우스_커버: 91, 휠하우스_커버_사진: 334 },
		],
	},
};
const REPORT_STATE_PASSENGER_FRONT = {
	state: {
		항목: [
			{ 휠: 101, 휠_사진: 106, 휠_내용: 107 },
			{ 제조사: 102 },
			{ 생산일: 103 },
			{ 트레드_잔량: 104 },
			{ 트레드_잔량_mm: 330, 휠_사진: 106 },
			{ 휠하우스_커버: 105, 휠하우스_커버_사진: 335 },
		],
	},
};
const REPORT_STATE_PASSENGER_BACK = {
	state: {
		항목: [
			{ 휠: 94, 휠_사진: 99, 휠_내용: 100 },
			{ 제조사: 95 },
			{ 생산일: 96 },
			{ 트레드_잔량: 97 },
			{ 트레드_잔량_mm: 329, 휠_사진: 99 },
			{ 휠하우스_커버: 98, 휠하우스_커버_사진: 336 },
		],
	},
};

const REPORT_BASIC_HAVE_FAULT_CHECK = {
	basic: {
		항목: [
			{ 차량키: 331, 차량키_사진: 332, 차량키_내용: 324 },
			{ 블랙박스: 13, 블랙박스_사진: 14, 블랙박스_내용: 15 },
			{ 정면유리_틴팅: 16, 정면유리_틴팅_사진: 18, 정면유리_틴팅_내용: 19 },
			{ 실내냄새: 17 },
		],
	},
};

const REPORT_STATE_TEXT = [
	{ ids: [81, 88, 102, 95], format: (text) => text }, // 타이어제조사
	{ ids: [82, 89, 103, 96], format: (text) => `${text.slice(0, 2)}주차 ${text.slice(2, 4)}년` }, // 타이어생산주기
	{ ids: [83, 90, 104, 97], format: (text) => `${text}%` }, // 타이어 트레드 %
	{ ids: [327, 328, 330, 329], format: (text) => `${text}mm` }, // 타이어 트레드 mm
];

const REPORT_STATE_TREAD_IDS = [327, 328, 330, 329];

const IMAGE_UPLOAD_OPTION = {
	useS3: true,
	bizType: 'HOME_SERVICE',
};

class CarVerificationEnum {
	constructor(codeType, nameType) {
		this.code = codeType;
		this.name = nameType;
	}

	getCode(key) {
		return this.code[key];
	}

	getName(key) {
		return this.name[key];
	}
}

const REPORT_GRADE = {
	S: {
		mainText: '이 차라면 누구나 갖고 싶을 거에요!',
		subText: '철저하게 관리되어 신차 같은 컨디션이에요.',
		tagText: [],
	},
	A: {
		mainText: '안심하고 탈 수 있는 좋은 선택이에요!',
		subText: '사용감이 적고 깔끔하게 관리되었어요.',
		tagText: [],
	},
	B: {
		mainText: '주저하지 말고 선택하세요!',
		subText: '사용감은 있지만 크게 눈에 띄지 않아요.',
		tagText: [],
	},
	C: {
		mainText: '합리적인 가격이 만족스러워요!',
		subText: '사용감은 있지만 기능 결함은 없어요.',
		tagText: ['합리적 가격'],
	},
	D: {
		mainText: '가성비를 고려한다면 좋은 선택이에요!',
		subText: '사용감이 있고 일부 정비가 필요할 수 있어요.',
		tagText: ['가성비'],
	},
};

const carVerificationType = {
	category: {
		basic: BASIC,
		interior: INTERIOR,
		state: STATE,
		exterior: EXTERIOR,
		etc: ETC,
		diagnosis: DIAGNOSIS,
	},
	diagnosisSubCategory: DIAGNOSIS_SUB_CATEGORY,
	categoryType: CATEGORY_TYPE,
	탭이름: new CarVerificationEnum(CATEGORY_TYPE, CATEGORY_TYPE_NAME),
	결함이름: new CarVerificationEnum(CATEGORY_TYPE, FAULT_OPTIONS),
	valueType: VALUE_TYPE,
	negativeOptions: OPTION_TYPE.NEGATIVE,
	차량검수_공통옵션: new CarVerificationEnum(COMMON_VALUE, COMMON_VALUE_NAME),
	사이드_리피터: {
		운전석: new CarVerificationEnum(COMMON_VALUE, COMMON_VALUE_NAME),
		동승석: new CarVerificationEnum(COMMON_VALUE, COMMON_VALUE_NAME),
	},
	전면램프: {
		운전석: new CarVerificationEnum(COMMON_VALUE, COMMON_VALUE_NAME),
		동승석: new CarVerificationEnum(COMMON_VALUE, COMMON_VALUE_NAME),
	},
	후면램프: {
		운전석: new CarVerificationEnum(COMMON_VALUE, COMMON_VALUE_NAME),
		동승석: new CarVerificationEnum(COMMON_VALUE, COMMON_VALUE_NAME),
	},
	소화기: new CarVerificationEnum(INCLUDE_VLAUE, INCLUDE_VLAUE_NAME),
	리페어장비: new CarVerificationEnum(INCLUDE_VLAUE, INCLUDE_VLAUE_NAME),
	번호판_램프: new CarVerificationEnum(COMMON_VALUE, COMMON_VALUE_NAME),
	차량키: new CarVerificationEnum(COMMON_VALUE, COMMON_VALUE_NAME),
	차량키수량: new CarVerificationEnum(KEY_QUANTITY, KEY_QUANTITY_NAME),
	제조사매뉴얼: new CarVerificationEnum(INCLUDE_VLAUE, INCLUDE_VLAUE_NAME),
	블랙박스: new CarVerificationEnum(INCLUDE_VLAUE, INCLUDE_VLAUE_NAME),
	정면유리_틴팅: new CarVerificationEnum(INCLUDE_VLAUE, INCLUDE_VLAUE_NAME),
	실내냄새: new CarVerificationEnum(SMELL, SMELL_NAME),
	진단_공통옵션: new CarVerificationEnum(DIAGNOSIS_VALUE, DIAGNOSIS_VALUE_NAME),
	변경_옵션명: new CarVerificationEnum(CHANGE_OPTION_VALUE, CHANGE_OPTION_NAME),
	photoGroup: PHOTO_GROUP,
	reportCarDetailIds: REPORT_CAR_DETAIL_IDS,
	reportCarDetailImageIds: REPORT_CAR_DETAIL_IMAGE_IDS,
	reportV2CarDetail: REPORT_V2_CAR_DETAIL,
	reportV2CarDetailIds: REPORT_V2_CAR_DETAIL_IDS,
	reportDisableMajorImage: REPORT_DISABLE_IMAGE_IDS,
	reportMajorExteriorImage: REPORT_EXTERIOR_IMAGE_IDS,
	reportMajorInteriorImage: REPORT_INTERIOR_IMAGE_IDS,
	reportMajorStateImage: REPORT_STATE_IMAGE_IDS,
	reportMajorEtcImage: REPORT_ETC_IMAGE_IDS,
	reportBasic: REPORT_BASIC,
	reportHaveFaultCheck: REPORT_BASIC_HAVE_FAULT_CHECK,
	reportBasicTotal: REPORT_BASIC_TOTAL,
	reportBasicPhoto: REPORT_BASIC_PHOTO,
	reportBasicNegative: REPORT_BASIC_NEGATIVE,
	reportLightPhoto: REPORT_LIGHT_PHOTO,
	reportLight: REPORT_LIGHT,
	reportInteriorMaterial: REPORT_INTERIOR_MATERIAL,
	reportInteriorMaterial2: REPORT_INTERIOR_MATERIAL2,
	reportInteriorSheet: REPORT_INTERIOR_SHEET,
	reportPhotoGroup: REPORT_PHOTO_GROUP,
	reportExteriorFront: REPORT_EXTERIOR_FRONT,
	reportExteriorDriver: REPORT_EXTERIOR_DRIVER,
	reportExteriorPassenger: REPORT_EXTERIOR_PASSENGER,
	reportExteriorRear: REPORT_EXTERIOR_REAR,
	reportExteriorRoof: REPORT_EXTERIOR_ROOF,
	reportExteriorGlass: REPORT_EXTERIOR_GLASS,
	reportStateFront: REPORT_STATE_FRONT,
	reportStateBack: REPORT_STATE_BACK,
	reportStatePassengerFront: REPORT_STATE_PASSENGER_FRONT,
	reportStatePassengerBack: REPORT_STATE_PASSENGER_BACK,
	reportStateText: REPORT_STATE_TEXT,
	reportFaultDesc: REPORT_FAULT_DESC,
	reportFaultDescMeetgo: REPORT_FAULT_DESC_MEETGO,
	reportTireTread: REPORT_STATE_TREAD_IDS,
	imageUploadOption: IMAGE_UPLOAD_OPTION,
	reportGrade: REPORT_GRADE,
	// 주행거리 등급(API mileageGrade) → 노출 레벨 (위키 PL-12139 3.주행거리 노출 정책)
	MILEAGE_GRADE_LEVEL: {
		NONE: '적은',
		VERY_LOW: '적은',
		LOW: '다소 적은',
		MEDIUM: '보통',
		HIGH: '다소 많은',
		VERY_HIGH: '많은',
	},
};

export default carVerificationType;
